// src/reducers/mealReducer.js

import { FETCH_MEALS_SUCCESS, ADD_MEAL_SUCCESS, UPDATE_MEAL_SUCCESS, DELETE_MEAL_SUCCESS } from '../actions/mealActions';

const initialState = {
  meals: [],
};

const mealReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MEALS_SUCCESS:
      return { ...state, meals: action.payload };
    case ADD_MEAL_SUCCESS:
      return { ...state, meals: [...state.meals, action.payload] };
    case UPDATE_MEAL_SUCCESS:
      return {
        ...state,
        meals: state.meals.map((meal) =>
          meal.meal_id === action.payload.meal_id ? action.payload : meal
        ),
      };
    case DELETE_MEAL_SUCCESS:
      return {
        ...state,
        meals: state.meals.filter((meal) => meal.meal_id !== action.payload),
      };
    default:
      return state;
  }
};

export default mealReducer;
